import { createClient } from '@supabase/supabase-js';
import { observeSupabaseClient } from './supabase-observe';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Please check your .env file.');
}

const baseClient = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
});

/** All PostgREST / RPC / edge invoke errors are reported to Sentry (see supabase-observe.ts). */
export const supabase = observeSupabaseClient(baseClient);